<template>
  <div class="swiper-card card-history">
    <div class="meta">
      <h3>{{ slide.byline }}</h3>
    </div>

    <div>
      <h1>{{ slide.title }}</h1>

      <div class="history">
        <div class="history-group" v-for="(history, idx) in getHistory" :key="idx">
          <h4 v-if="history.date">{{ history.date | date }}</h4>
          <div class="stories">
            <div class="story" v-for="story in history.stories" :key="story.slug">
              <router-link :to="`/story/${story.slug}`" class="story-link">
                <div class="story-content-wrapper">
                  <div class="story-content">
                    <h4 v-if="story.name" class="story-name">{{ story.name }}</h4>
                    <div class="story-meta-wrapper">
                      <span class="story-meta">
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.7812 6.5C11.7812 7.90067 11.2248 9.24398 10.2344 10.2344C9.24398 11.2248 7.90067 11.7812 6.5 11.7812C5.09933 11.7812 3.75602 11.2248 2.76559 10.2344C1.77517 9.24398 1.21875 7.90067 1.21875 6.5C1.21875 5.09933 1.77517 3.75602 2.76559 2.76559C3.75602 1.77517 5.09933 1.21875 6.5 1.21875C7.90067 1.21875 9.24398 1.77517 10.2344 2.76559C11.2248 3.75602 11.7812 5.09933 11.7812 6.5ZM0 6.5C0 8.22391 0.68482 9.87721 1.90381 11.0962C3.12279 12.3152 4.77609 13 6.5 13C8.22391 13 9.87721 12.3152 11.0962 11.0962C12.3152 9.87721 13 8.22391 13 6.5C13 4.77609 12.3152 3.12279 11.0962 1.90381C9.87721 0.68482 8.22391 0 6.5 0C4.77609 0 3.12279 0.68482 1.90381 1.90381C0.68482 3.12279 0 4.77609 0 6.5ZM5.89062 3.04688V6.5C5.89062 6.70312 5.99219 6.89355 6.1623 7.00781L8.5998 8.63281C8.8791 8.8207 9.25742 8.74453 9.44531 8.4627C9.6332 8.18086 9.55703 7.80508 9.2752 7.61719L7.10938 6.175V3.04688C7.10938 2.70918 6.8377 2.4375 6.5 2.4375C6.1623 2.4375 5.89062 2.70918 5.89062 3.04688Z" fill="black"/>
                        </svg>
                        {{ story.last_published_at | ago }}
                      </span>
                      <div class="item-mood" :class="getMood(story.mood).code">
                        <div class="item-mood-marker"></div>
                        <span>{{ getMood(story.mood).name }}</span>
                      </div>
                    </div>
                  </div>

                  <div onerror="this.style.display='none'" class="inner-image">
                    <img :src="story.image" :alt="story.name" />
                  </div>
                </div>

                <span v-if="story.synopsis" class="story-stack">{{ story.synopsis }}</span>

                <ul class="meta" :title="story.last_published | date">
                  <router-link v-for="(topic, idx) in story.topics.slice(0, 3)" :key="`story-${idx}-${story.slug}-topic-${topic.topic_code}`" :to="`/topic/${topic.topic_code}`" @click.native.stop>
                    <li>{{ topic.topic_name }}</li>
                  </router-link>
                </ul> 
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      slide: {
        type: Object,
      },
      stories: {
        type: Array,
      },
    },

    mounted () {
      this.$watch('$route.params.stack', (slug) => {
        if (slug === this.slide.slug) {
          this.$emit('swiperUpdate');
          this.$emit('enableNextAction');
        }
      }, { immediate: true });
    },

    methods: {
      routeStory(slug) {
        if (!slug) { return; }
        this.$router.push(`/story/${slug}`)
      },

      getMood(mood) {
        if (mood < -0.25) {
          return {
            code: 'negative',
            name: 'Negative'
          }
        } else if (mood > 0.25) {
          return {
            code: 'positive',
            name: 'Positive'
          }
        }

        return {
          code: 'neutral',
          name: 'Neutral'
        }
      },
    },

    computed: {
      getHistory() {
        if (this.slide.history) {
          return this.slide.history;
        }

        const stories = this.stories;

        if (!stories || !Array.isArray(stories)) return [];

        let rtn = [{
          date: null,
          stories: stories,
        }];

        // const grouped = {};
        // stories.forEach(story => {
        //   const date = story.last_published_at
        //     ? new Date(story.last_published_at).toISOString().split('T')[0]
        //     : 'Unknown';
        //   if (!grouped[date]) grouped[date] = [];
        //   grouped[date].push(story);
        // });

        // let rtn = Object.keys(grouped)
        //   .sort((a, b) => b.localeCompare(a))
        //   .map(date => ({
        //     date,
        //     stories: grouped[date]
        //   }));

        return rtn;
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-history {
    padding: 1rem 0;

    h3 {
      color: $yellow-tone-4;

      .darkmode & {
        color: $yellow-tone-3;
      }
    }

    .history {
      display: flex;
      flex-direction: column;
      margin-top: 2rem;
      gap: 2rem;

      .history-group {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;

        .stories {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          width: 100%;

          .story-link {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            padding: 1rem 1rem 1rem 1rem;
            gap: 0.75rem;
          }

          .story-content-wrapper {
            display: flex;
            justify-content: space-between;
            width: 100%;
          }

          .story {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            width: 100%;
            background: rgba($neutral-400, 0.05);
            border-radius: 10px;
            color: $neutral-100;
            border-left: 2px solid transparent;
            cursor: pointer;
            transition: all 0.2s ease-in-out;

            .darkmode & {
              color: $neutral-600;
            }

            &:hover {
              background: rgba($neutral-400, 0.15);
            }

            .story-image {
              width: auto;
            }

            .inner-image {
              width: 4rem;
              height: 4rem;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 6px;
              }
            }

            .item-mood {
              display: flex;
              align-items: center;
              gap: 0.3rem;
              background: none;
              padding-top: 1px;

              .item-mood-marker {
                width: 7px;
                height: 7px;
                border-radius: 500px;
              }

              span {
                display: inline-block;
                font-size: 0.8rem;
                color: $neutral-400;
                padding-bottom: 1px;
              }

              &.positive {
                color: $green-tone-3;
                .item-mood-marker {
                  background: $green-tone-3;
                }
              }

              &.neutral {
                color: $blue-tone-3;
                .item-mood-marker {
                  background: $blue-tone-3;
                }
              }

              &.negative {
                color: $red-tone-3;
                .item-mood-marker {
                  background: $red-tone-3;
                }
              }
            }

            .story-content {
              display: flex;
              flex-direction: column;
              gap: 0.4rem;
              flex: 1;

              .story-name {
                font-size: 1.1rem;
                line-height: 140%;
              }

              .story-meta-wrapper {
                display: flex;
                align-items: center;
                margin-bottom: 0.25rem;

                .story-meta {
                  display: flex;
                  align-items: center;
                  font-size: 0.8rem;
                  color: $neutral-400;

                  svg {
                    margin-top: 1px;
                    margin-right: 0.3rem;
                    
                    path {
                      fill: $neutral-400;
                    }
                  }

                  &:not(:last-child) {
                    &::after{
                      content: '|';
                      margin: 0 0.4rem;
                      color: $neutral-400;
                    }
                  }
                }
              }
            }

            .story-stack {
              font-size: 0.8rem;
              color: $neutral-400;
              line-height: 140%;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .meta {
              display: flex;
              flex-wrap: wrap;
              font-size: 0.8rem;
              gap: 0.5rem;
              padding-bottom: 0.5rem;

              li {
                color: $neutral-400;
                border-bottom: 1px solid $neutral-400;
                padding-bottom: 2px;
                transition: all 0.2s ease-in-out;

                &:hover {
                  color: $neutral-100;
                  border-bottom: 1px solid $neutral-100;

                  .darkmode & {
                    color: $neutral-600;
                    border-bottom: 1px solid $neutral-600;
                  }
                }
              }
            }
          }

          .story-image {
            width: 100%;
          }

          .inner-image {
            width: 100%;
            height: 10rem;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-top-left-radius: 6px;
              border-top-right-radius: 6px;
            }
          }

          // .story {
          //   display: flex;
          //   align-items: flex-start;
          //   padding: 1rem;
          //   gap: 1rem;
          //   width: 100%;
          //   background: rgba($neutral-400, 0.08);
          //   border-radius: 10px;
          //   color: $neutral-100;

          //   .darkmode & {
          //     color: $neutral-600;
          //   }

          //   .inner-image {
          //     width: 3rem;
          //     height: 3rem;
          //     object-fit: cover;
          //     border-radius: 10px;
          //   }

          //   .story-content {
          //     display: flex;
          //     flex-direction: column;
          //     gap: 0.4rem;
          //     flex: 1;

          //     .story-name {
          //       font-family: 'Brawler';
          //       font-size: 1.1rem;
          //       line-height: 140%;
          //     }

          //     .story-stack {
          //       font-size: 0.8rem;
          //       color: $neutral-400;
          //       line-height: 140%;
          //       display: -webkit-box;
          //       -webkit-line-clamp: 2;
          //       -webkit-box-orient: vertical;
          //       overflow: hidden;
          //     }
          //   }
          // }
        }
      }
    }
  }
</style>